<template>
    <div class="card h-12rem w-full">
        <div class="flex gap-3">
            <Skeleton width="5rem" class="mb-2" borderRadius="16px" />
            <Skeleton width="10rem" class="mb-2" borderRadius="16px" />
        </div>
        <div class="flex flex-column">
            <span class="text-center">Loading Comments.. </span>
            <div class="flex justify-content-center">
                <MoonLoader />
            </div>
        </div>
        <div>
            <Skeleton height="4rem" class="mb-2" borderRadius="16px" />
        </div>
    </div>
</template>

<script setup></script>
